import React, { useState,useEffect,useRef} from "react";
import { useNavigate, Link } from "react-router-dom";

import axios from "axios";
import { parseJwt } from "../../utils/helper";
const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if token exists in localStorage
    const token = localStorage.getItem("token");

    if (!token) {
      // Redirect to login if not logged in
      navigate("/business/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    // Clear the token from localStorage
    localStorage.removeItem("token");
    // Redirect to login page
    navigate("/business/login");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false); // Close the sidebar if clicked outside
      }
    };

    // Attach event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const token = localStorage.getItem('token');
  const decodedToken = parseJwt(token);
  const userId = decodedToken?.id; 
  const [businessSlug, setBusinessSlug] = useState(null);
  
  useEffect(() => {
    // Fetch business details using userId
    const fetchBusinessSlug = async () => {
      try {
        
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/business/user/${userId}`);
        setBusinessSlug(response.data.slug); // Assuming the response contains business_id
      } catch (error) {
        console.error('Error fetching business details:', error);
      }
    };

    if (userId) {
      fetchBusinessSlug(); // Only fetch business ID if userId is present
    }
  }, [userId]); 

  
  return (
    <div>
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={` bg-yellow-50 shadow-lg text-black w-72 space-y-6 py-4 z-50 absolute inset-y-0 left-0 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }  transition duration-200 ease-in-out`}
      >
        {/* Logo */}
        <div className="">
        <header className="flex w-full items-center gap-4 px-6 ">
          {/* Hamburger Menu */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-black  focus:outline-none"
          >
            <i className="fa-regular fa-close hover:bg-gray-100 hover:scale-110 rounded-2xl px-2 text-2xl"></i>
          </button>
          <div className="flex items-center space-x-2">
          <img src="/logobl.png" className="h-[calc(64px-1rem)]" alt="" />
          </div>
        </header>
      </div>

        {/* Navigation */}
        <nav className="space-y-4 text-xl md:text-base">
          <Link
            to="/business/dashboard/"
            className="flex items-center px-8 py-2 text-black hover:bg-gray-200  "
          >
            <i className="fa-regular fa-star mr-3"></i>
            <span>REVIEWS</span>
          </Link>
          <Link
            to="/business/dashboard/helpdesk"
            className="flex items-center px-8 py-2 text-black hover:bg-gray-200  "
          >
            <i className="fa-regular fa-phone mr-3"></i>
            <span>SUPPORT</span>
          </Link>
          <Link
            to="/business/dashboard/profile"
            className="flex items-center px-8 py-2 text-black hover:bg-gray-200  "
          >
            <i className="fa-regular fa-lock mr-3"></i>
            <span>PASSWORD</span>
          </Link>
          <Link
            to={`/review/${businessSlug}`}
            target="_blank"
            className="flex items-center px-8 py-2 text-black hover:bg-gray-200  "
          >
            <i className="fa-regular fa-star mr-3"></i>
            <span>RATING PAGE</span>
          </Link>
          <button
          onClick={handleLogout}
          className="flex items-center px-8 py-2 text-black w-full hover:bg-gray-200  "
        >            <i className="fa-regular fa-sign-out mr-3"></i>
          <span>LOGOUT</span>
        </button>
        
        </nav>
      </div>

      {/* Content */}
      <div className="shadow-md text-black w-full">
        <header className="flex w-full items-center gap-4  bg-yellow-300 text-black py-4 px-6 ">
          {/* Hamburger Menu */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-black focus:outline-none"
          >
            <i className="fa-regular fa-bars   hover:scale-110 rounded-2xl px-2 text-2xl"></i>
          </button>
          <div className="flex items-center space-x-2">
          <img src="/logobl.png" className="h-[calc(64px-1rem)]" alt="" />
          </div>
        </header>
      </div>
    </div>
  );
};

export default Sidebar;
